import Vue from 'vue'
import {
  Loading,
  Dialog,
  Pagination,
  RadioGroup,
  RadioButton
} from 'element-ui'

const elementui = function () {
  Vue.use(Loading)
  Vue.use(Dialog)
  Vue.use(Pagination)
  Vue.use(RadioGroup)
  Vue.use(RadioButton)
}

export default elementui



// WEBPACK FOOTER //
// ./src/utils/element-ui.js